import axios from 'axios'
import { i18n } from '../main'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer ' + token;
    }
    config.headers.lang = i18n.locale.toUpperCase()
    return config;
  },
  (error) => Promise.reject(error),
);

const apiFileClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  responseType: 'blob'
})

apiFileClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer ' + token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default {
  postKeys(keyPair) {
    return apiClient.put('/stripe/payment_details', keyPair)
  },
  getKeys(productId) {
    return apiClient.get(`/stripe/payment_details/${productId}`)
  },
  getPaymentIntent(productId, body) {
    return apiClient.post(`/create-payment-intent/${productId}`, body)
  },
  getPaymentMethod(paymentMethodId, cartId) {
    return apiClient.get(`/retrieve/paymentMethod/${paymentMethodId}/cart/${cartId}`)
  },
  getAdminPublishableKey() {
    return apiClient.get('/admin/publishableKey')
  },
  fetchInvoiceZip(body) {
    return apiFileClient.post('/guest/invoices', body)
  },
  fetchVATReport(body) {
    return apiFileClient.post('/vat/report', body)
  },
  fetchFilteredInvoices(month, year) {
    if(!month || !year)
      return apiClient.get(`/invoices`)
    return apiClient.get(`/invoices?month=${month}&year=${year}`)
  }
}